import { TextField, styled } from "@mui/material";

interface PillTextFieldProps {
  isSelected?: boolean;
}

const PillTextField = styled(TextField, {
  shouldForwardProp: (prop) => {
    return prop !== "isSelected";
  },
})<PillTextFieldProps>(({ theme, isSelected }) =>
  theme.unstable_sx({
    flexShrink: 0,
    backgroundColor: "white",
    ".MuiInputBase-root": {
      padding: theme.spacing(0, 1),
      border: "1px solid",
      borderRadius: "100px",
      borderColor: isSelected ? "grey.500" : "transparent",
      "&.Mui-focused, &:hover": {
        borderColor: "divider",
      },
      height: "100%",
      ".MuiInputBase-input": {
        width: "auto",
        "&, &::placeholder": {
          opacity: 1,
        },
      },
    },
    ".MuiInputAdornment-positionStart": {
      ".MuiSvgIcon-root": {
        color: "black",
      },
    },
    fieldset: {
      display: "none",
    },
    ".MuiInputBase-input": {
      fontWeight: isSelected ? "1000 !important" : "normal",
    },
  }),
);

export default PillTextField;
